import { TemplateRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { TabItem } from "../models/tab-item-model";

export class TabFactory {
    public tabList: TabItem[] = [];
    public addTab(label: string,routeName: string, template: TemplateRef<any>, visibility = true, active: boolean = false, permission: string = '') {
        if (!this.exist(routeName)) {
            const newTab = new TabItem();
            newTab.label = label;
            newTab.name = routeName;
            newTab.permission = permission;
            newTab.template = template;
            newTab.children = [];
            newTab.visibility = visibility;
            newTab.active = active;
            this.tabList.push(newTab);
        }
    }

    public remove(name: string) {

    }

    public find(name: string): number {
        const value = this.tabList.reduce((acc, curr) => curr.name === name ? acc = curr: acc = acc);
        return this.tabList.indexOf(value, 0);
    }

    public exist(name:string): boolean {
        return this.tabList.filter(x => x.name === name).length > 0;
    }
}